import React, { useState } from "react";
import {
  TextInput,
  Text,
  Button,
  Group,
  SimpleGrid,
  Modal,
} from "@mantine/core";
//import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";
import { Link, useNavigate } from "react-router-dom";

const CreateEventModal = ({ openModal, setOpenModal, eventID }) => {
  const [eventName, setEventName] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    apiWithInterceptor
      .post("/event", {
        name: eventName,
        description: eventDescription,
      })
      .then(function (response) {
        console.table(response);
        const id = response.data.id;
        const name = response.data.name;
        const description = response.data.description;

        showNotification({
          title: ` ${response?.request?.statusText}`,
          message: "Event Successfuly created",
          color: "green",
        });
        setOpenModal(false);
        navigate(`/app/events/create-session/${id}`, {
          state: {
            name: name,
            description: description,
            id: id,
          },
        });
        setEventDescription("");
        setEventName("");
      })
      .catch(function (error) {
        showNotification({
          title: "Failed to create a new Event",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  };

  const handleUpdate = () => {
    apiWithInterceptor
      .patch(`/event/${eventID}`, {
        name: eventName,
        description: eventDescription,
      })
      .then(function (response) {
        showNotification({
          title: ` ${response?.request?.statusText}`,
          message: "Event Successfully created",
          color: "green",
        });
        setOpenModal(false);
        setEventDescription("");
        setEventName("");
      })
      .catch(function (error) {
        showNotification({
          title: "Failed to create a new Event",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  };
  return (
    <>
      <Group position="center">
        <Modal
          title={eventID === null ? "New Event" : "Update Event"}
          opened={openModal}
          onClose={() => setOpenModal(false)}
        >
          <SimpleGrid verticalSpacing="lg">
            <Text>
              Make sure to create a{" "}
              <span style={{ color: "#ffa500", fontWeight: "bold" }}>FORM</span>{" "}
              for your event's session before creating the event{" "}
              <Link
                style={{ color: "#ffa500", fontWeight: "bold" }}
                to="/app/createform"
              >
                click here
              </Link>{" "}
              if you didn't
            </Text>
            <TextInput
              label="Event name"
              placeholder="Enter the event name"
              data-autofocus
              onChange={(e) => setEventName(e.target.value)}
            />
            <TextInput
              label="Event description"
              placeholder="Enter the event description"
              data-autofocus
              onChange={(e) => setEventDescription(e.target.value)}
            />
            <Button
              fullWidth
              onClick={() => {
                if (eventID === null) handleSubmit();
                else {
                  handleUpdate();
                }
              }}
            >
              {eventID === null
                ? "Submit Event & Add sessions"
                : "Update Event & Add sessions"}
            </Button>
            <Button
              color="red"
              fullWidth
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Cancel
            </Button>
          </SimpleGrid>
        </Modal>
      </Group>
    </>
  );
};

export default CreateEventModal;
